// extracted by mini-css-extract-plugin
export var dateContainer = "Date_dateContainer__tgFDC";
export var dateInput = "Date_dateInput__B1l6D";
export var dateInputInputsWrapper = "Date_dateInputInputsWrapper__TbHDv";
export var md = "768px";
export var shared = "\"../../../shared.module.css\"";